class SignInRedirectError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SignInRedirectError';
  }
}

export default SignInRedirectError;
